import qs from 'query-string';
import { all, put, takeLatest } from 'redux-saga/effects';

import {
  GET_EVIDENCE_LIST,
  GET_EVIDENCE_LIST_FAILURE,
  GET_EVIDENCE_LIST_SUCCESS,
} from '../../modules/constants';
import { defaultApi } from '../../utils/axiosApi';

export function* handleGetEvidenceList({ payload }) {
  const { startDate, endDate, taskCode, officeId, userId, page } = payload;
  try {
    const queryParams = {
      start: startDate,
      end: endDate,
      office_id: officeId,
      task_code: taskCode, // The taskId should be a string
      created_by: userId,
      page: page
    };

    const keysOrder = Object.keys(queryParams);
    const queryString = qs.stringify(queryParams, {
      skipEmptyString: true,
      skipNull: true,
      sort: (a, b) => keysOrder.indexOf(a) - keysOrder.indexOf(b),
    });

    const url = `albait/task-photo-evidences/?${queryString}`;

    const response = yield defaultApi(url, 'GET', null);

    yield put({
      type: GET_EVIDENCE_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_EVIDENCE_LIST_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    // Get tasks list
    takeLatest(GET_EVIDENCE_LIST, handleGetEvidenceList),
  ]);
}
